/** SkeletonModifier3D parser: the Node3D base parse plus `active` and `influence`. */
import { boolOr, realOr } from '../../../../parser/valueParsers';
import { parseNode3D } from '../../../base/node3d/parser';
export function parseSkeletonModifier3D(heading, properties) {
    return {
        ...parseNode3D(heading, properties),
        active: boolOr(properties.active, true, 'SkeletonModifier3D active'),
        influence: realOr(properties.influence, 1, 'SkeletonModifier3D influence'),
    };
}
//# sourceMappingURL=parser.js.map